import styled from "styled-components";

export const CardExpandContainer = styled.div.attrs({})`
  border-radius: 8px;
`;

export const CardExpandContainerHeader = styled.div.attrs({})`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 14px 22px;

  border-radius: 8px;
  box-shadow: 0px 3px 6px ${(p) => p.theme.palette.colors.shadow};
  background: ${(props) => props.theme.palette.colors.white};


  cursor: pointer;
`;

export const CardExpandContainerHeaderTitle = styled.div.attrs({})`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 18px;

  & p {
    font-size: 18px;
    font-weight: 500;
    color: #2E2B33;

    margin: 0;
  }
`;

export const CardExpandContainerBody = styled.div.attrs({})`
  display: flex;
  flex-direction: column;
  padding: ${(props) => (props.active ? "16px 16px 0px;" : "0")};
  max-height: ${(props) => (props.active ? "1000px" : "0")};
  min-height: 0;

  overflow: hidden;
  
  transition: max-height 0.8s ease-in-out, padding 1s ease-in-out;
`;

export const CardHomeContentLabel = styled.div.attrs({})`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;

  & p {
    font-size: 12px;
    color: ${(props) => props.theme.palette.colors.text};
    margin: 0;
  }
`;

export const CardHomeContentLabelDecoration = styled.img.attrs((props) => ({
  src: `/images/${props.icon}.png`,
}))`
  width: 35px;
  height: 35px;
`;

export const CardHomeContentLabelDecorationTikTok = styled.img.attrs((props) => ({
  src: "/icons/tiktok-grey.svg",
}))`
  width: 32px;
  height: 32px;
`;

export const CardHomeContentLabelDecorationInstagram = styled.img.attrs((props) => ({
  src: "/icons/insta-grey.svg",
}))`
  width: 32px;
  height: 32px;
`;
